import { collection, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';

export interface ErrorLog {
  userId?: string;
  userEmail?: string;
  location: string;
  message: string;
  stack?: string;
  context?: any;
  createdAt: string;
  userAgent: string;
}

export async function logError(message: string, context?: any, error?: any) {
  try {
    const errorLog: ErrorLog = {
      userId: auth.currentUser?.uid,
      userEmail: auth.currentUser?.email || undefined,
      location: window.location.href,
      message,
      stack: error?.stack || (error instanceof Error ? error.stack : undefined),
      context: context ? JSON.parse(JSON.stringify(context)) : undefined, // Ensure it's serializable
      createdAt: new Date().toISOString(),
      userAgent: navigator.userAgent
    };

    console.warn("[Logger] Capturing error:", message, errorLog);
    await addDoc(collection(db, 'error_logs'), errorLog);
  } catch (err) {
    console.error("[Logger] Failed to log error to Firestore:", err);
    // Final fallback to console if writing to Firestore fails
    console.warn("[Logger] Original error being captured:", {
      message,
      context,
      userId: auth.currentUser?.uid || 'anonymous'
    });
  }
}
